import { render, staticRenderFns } from "./InvestmentManagerDetail.vue?vue&type=template&id=17176a98&"
import script from "./InvestmentManagerDetail.vue?vue&type=script&lang=js&"
export * from "./InvestmentManagerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports